const v1 = {
    NEW_AUTHER: false,
    NEW_LOGIN_UI: false
};

const v2 = {
    NEW_AUTHER: true,
    NEW_LOGIN_UI: true
};

const siteSettings = {
    v1,
    v2
};

export const buildSettings = siteSettings[ process.env.REACT_APP_SETTINGS_KEY ] ?? siteSettings.v2;